import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, OnDestroy } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { Notification } from './notification.model';
import { SIGNALR_BASE_SERVICE_FACTORY, SignalRFactory, SignalRService } from './signalr.service';

@Injectable({ providedIn: 'root' })
export class NotificationService implements OnDestroy {
  private notificationsEndpoint = '/api/notifications';
  private readonly signalrService: SignalRService;

  constructor(private http: HttpClient, @Inject(SIGNALR_BASE_SERVICE_FACTORY) makeSignalR: SignalRFactory) {
    this.signalrService = makeSignalR();
    this.signalrService.initialize('/hubs/notifications');
  }

  async markNotificationAsRead(id: number): Promise<void> {
    const put$: Observable<void> = this.http.put<void>(
      `${environment.apiUrl}${this.notificationsEndpoint}/${id}/read`,
      null,
    );
    return await firstValueFrom(put$);
  }

  async getNotificationsByAssignedTo(assignedTo: string): Promise<Notification[]> {
    const notifications$: Observable<Notification[]> = this.http.get<Notification[]>(
      `${environment.apiUrl}${this.notificationsEndpoint}?assignedTo=${assignedTo}`,
    );
    return await firstValueFrom(notifications$);
  }

  listenToCreatedNotifications(): Observable<Notification> {
    return this.signalrService.addListener('NotificationCreated');
  }

  ngOnDestroy(): void {
    this.signalrService.destroy();
  }
}
